import countries from "@components/PhoneInput/data/countries";
import { OrderFields } from "@modules/order/constants";
import { TOrderFormData } from "@modules/order/models/orderForm";
import { TPackageSize } from "@modules/order/types";
import { TPaymentMethod } from "@modules/payment-methods";
import formatCurrency from "@utils/formatCurrency";

import { TGTMData } from "./types";

const mapOrderValuesToGTMValues = (
  orderValues: TOrderFormData,
  packageSizes: TPackageSize[],
  paymentMethods: TPaymentMethod[]
): TGTMData => ({
  deliveryMethod: orderValues[OrderFields.DELIVERY_METHOD],
  countryFrom: countries.find((country) => country.shortName === orderValues[OrderFields.STARTING_COUNTRY])?.label,
  countryTo: countries.find((country) => country.shortName === orderValues[OrderFields.DESTINATION_COUNTRY])?.label,
  price: formatCurrency(orderValues[OrderFields.PRICE] || 0.0).replace(",", "."),
  packageSize: orderValues[OrderFields.PACKAGE_SIZE],
  promoCode: orderValues[OrderFields.PROMO_CODE],
  option:
    paymentMethods.find((paymentMethod) => paymentMethod.code === orderValues[OrderFields.PAYMENT_METHOD])?.gtmName ||
    "",
  identification: "",
});

export default mapOrderValuesToGTMValues;
